<template>
  <div class="content-top-padding padding-for-footer" v-cloak>
    <div class="container my-5">
          <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'Initiatives' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'Initiatives' }" class="">
            {{ $t("title.init") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'Landing' }" class="">
            {{ $t("title.home") }}
          </router-link>
          <router-link :to="{ name: 'Landing' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
      <div class="row d-flex flex-column mb-5">
        <div class="col">
          <h3 class="main-theme mb-5 text-uppercase font-weight-bold">
            {{ $t("title.aboutUs") }}
          </h3>
        </div>
      </div>

      <div
        class="
          row
          main-theme
          d-flex
          justify-content-center
          text-uppercase text-center
          mb-5
        "
      >
        <div class="col-10 col-md-10 col-lg-3 align-self-end">
          <a :href="[$i18n.locale == 'zh' ? pdfPath.tc.award : pdfPath.en.award]" download>
            <div class="title mb-4">
              <h3 class="font-weight-bold">{{ $t("title.award") }}</h3>
            </div>
            <div class="thumbnail mb-5 mb-lg-0">
              <img alt="" src="../assets/aboutUs/hktb_01.jpg" />
            </div>
          </a>
   
        </div>
        <div class="col-10 col-md-10 col-lg-3 align-self-end">
          <router-link :to="{ name: 'Map' }">
            <div class="title mb-4">
              <h3 class="font-weight-bold">{{ $t("title.worldwide") }}</h3>
            </div>
            <div class="thumbnail mb-5 mb-lg-0">
              <img alt="" src="../assets/aboutUs/hktb_02.jpg" />
            </div>
          </router-link>
        </div>
        <div class="col-10 col-md-10 col-lg-3 align-self-end">
          <a :href="pdfPath.tc.corp" download v-if="$i18n.locale == 'zh'">
            <div class="title mb-4">
              <h3 class="font-weight-bold">{{ $t("title.corp") }}</h3>
            </div>
            <div class="thumbnail mb-5 mb-lg-0">
              <img alt="" src="../assets/aboutUs/hktb_03.jpg" />
            </div>
          </a>
          <a :href="pdfPath.en.corp" download v-else>
            <div class="title mb-4">
              <h3 class="font-weight-bold">{{ $t("title.corp") }}</h3>
            </div>
            <div class="thumbnail mb-5 mb-lg-0">
              <img alt="" src="../assets/aboutUs/hktb_03.jpg" />
            </div>
          </a>
        </div>
        <div class="col-10 col-md-10 col-lg-3 align-self-end">
          <a :href="pdfPath.tc.report" download v-if="$i18n.locale == 'zh'">
            <div class="title mb-4">
              <h3 class="font-weight-bold">{{ $t("title.report") }}</h3>
            </div>
            <div class="thumbnail mb-5 mb-lg-0">
              <img alt="" src="../assets/aboutUs/hktb_04.jpg" />
            </div>
          </a>
          <a :href="pdfPath.en.report" download v-else>
            <div class="title mb-4">
              <h3 class="font-weight-bold">{{ $t("title.report") }}</h3>
            </div>
            <div class="thumbnail mb-5 mb-lg-0">
              <img alt="" src="../assets/aboutUs/hktb_04.jpg" />
            </div>
          </a>
        </div>
      </div>

      <!-- <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'Initiatives' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'Initiatives' }" class="">
            {{ $t("title.init") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'Landing' }" class="">
            {{ $t("title.home") }}
          </router-link>
          <router-link :to="{ name: 'Landing' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  components: {},
  metaInfo: {
    title: "About Us",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
  data() {
    return {
      pdfPath: {
        en: {
          award: "pdf/en/5-1-Awards & Achievements.pdf",
          corp: "pdf/en/5-3-Corporate Information.pdf",
          report: "pdf/en/5-4-Independent Auditor's Report.pdf",
        },
        tc: {
          award: "pdf/tc/5-1-Awards & Achievements.pdf",
          corp: "pdf/tc/5-3-Corporate Information.pdf",
          report: "pdf/tc/5-4-Independent Auditor's Report.pdf",
        },
      },
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.thumbnail {
  img {
    width: 100%;
  }
}
.title {
  h3 {
    font-size: 1.5rem;
  }
}
</style>
